<template>
  <div class="text-center z5">
    <v-card height="100%">
      <v-row no-gutters class="full-height">
        <v-col cols="12">
          <v-divider />
          <v-card-text class="pa-0">
            <ResourcesTabList :session="session" />
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import ResourcesTabList from '../InstructorHorse/ResourcesTabList.vue';

export default {
  components: { ResourcesTabList },
  props: {
    session: {
      type: Object,
      default: null
    }
  }
};
</script>
